import { EqlField } from 'generated/graphql';
import { CommonFieldDetailsTooltipContent } from '../CommonFieldDetailsTooltipContent';

interface FieldDetailsTooltipContentProps {
  field: EqlField;
}

export const FieldDetailsTooltipContent = ({
  field,
}: FieldDetailsTooltipContentProps) => {
  const isCommonField = field.detail?.metadata?.source === 'Common';

  if (isCommonField) {
    return <CommonFieldDetailsTooltipContent field={field} />;
  }

  return null;
};
